import { render, staticRenderFns } from "./RecipeSort.vue?vue&type=template&id=9c7ebc58&"
import script from "./RecipeSort.vue?vue&type=script&lang=ts&"
export * from "./RecipeSort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports